import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, GroupOfResearches } from "../../types"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<GroupOfResearches>()

export function TableGroupOfResearchess({
  groupsOfResearches,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  groupsOfResearches: GroupOfResearches[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!groupsOfResearches) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [groupsOfResearches, count])

  return (
    <Table
      data={groupsOfResearches}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Nome"
        name="name"
        sortable
        width="minmax(max-content, 1fr)"
        render={(group) => (
          <Link to={`/group-of-researches/group-of-researches/${group.id}`}>
            <LinkMagik className="text-dark">{group.name}</LinkMagik>
          </Link>
        )}
        stickyLeft
        icon="person"
        // TODO badge
      />

      <Table.Column
        title="Università"
        name="university"
        sortable
        width="minmax(max-content, 1fr)"
        render={(group) => <div className="text-dark">{group.university}</div>}
      />

      <Table.Column
        title="Ordine"
        name="order"
        sortable
        width="minmax(max-content, 1fr)"
        render={(group) => {
          return group.order
        }}
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} gruppi di ricerche
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
